module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.8514/images/header-bg.svg"